<div class="einvoice-tin-select-input">
  <div class="input-container">
    <input
      type="text"
      class="form-input"
      [(ngModel)]="displayValue"
      (ngModelChange)="onInputChange($event)"
      (focus)="onInputFocus()"
      (blur)="onInputBlur()"
      [placeholder]="placeHolder"
      [disabled]="disabled"
      [maxlength]="maxChar"
      [required]="isRequired"
    />
    <div class="dropdown" *ngIf="showDropdown && filteredOptions.length > 0">
      <div 
        class="dropdown-item" 
        *ngFor="let option of filteredOptions"
        (mousedown)="selectOption(option)"
      >
        {{ option.value }} - {{ option.label }}
      </div>
    </div>
  </div>
</div>